import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { applySeason, resolveSeason } from './lib/seasons';
import './styles/index.css';

applySeason(document.documentElement, resolveSeason(new Date(), window.location.search));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
